import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import Notification from "../components/common/Notification";
import styles from "./AdminPage.module.css";
import axios from "axios";

// --- FULL PAGE CONFIGURATION (WITH SMART REPEATERS) ---
const PAGE_CONFIG = {
  about: {
    title: "Edit About Us",
    sections: [
      {
        sectionTitle: "Hero & Story",
        fields: [
          {
            key: "heroTitle",
            label: "Main Title",
            type: "text",
            default: "About Us",
          },
          {
            key: "storyTitle",
            label: "Story Heading",
            type: "text",
            default: "Our Story",
          },
          {
            key: "storyText",
            label: "Story Paragraph",
            type: "textarea",
            default: "Dukamo Coffee was born from a passion...",
          },
          { key: "storyImage1", label: "Story Image 1 (Left)", type: "image" },
          { key: "storyImage2", label: "Story Image 2 (Right)", type: "image" },
        ],
      },
      {
        sectionTitle: "Founder Details",
        fields: [
          {
            key: "kormaTitle",
            label: "Founder Title",
            type: "text",
            default: "Dukamo Korma (ADARA)",
          },
          {
            key: "kormaText",
            label: "Founder Bio",
            type: "textarea",
            default: "Named in honor of our beloved grandfather...",
          },
          { key: "kormaImage", label: "Founder Image", type: "image" },
        ],
      },
    ],
  },

  roastery: {
    title: "Edit Roastery Page",
    sections: [
      {
        sectionTitle: "Hero & Intro",
        fields: [
          {
            key: "heroTitle",
            label: "Hero Title",
            type: "text",
            default: "Inherited Energy",
          },
          {
            key: "buyNowBtnText",
            label: "Hero Button Text",
            type: "text",
            default: "Buy Now",
          },
          { key: "intro1Image", label: "Intro 1 Image (Left)", type: "image" },
          {
            key: "intro1Title",
            label: "Intro 1 Title",
            type: "text",
            default: "Dukamo Coffee",
          },
          {
            key: "intro1Text",
            label: "Intro 1 Text",
            type: "textarea",
            default: "Everyone deserves good coffee...",
          },
          { key: "intro2Image", label: "Intro 2 Image (Right)", type: "image" },
          {
            key: "intro2Title",
            label: "Intro 2 Title",
            type: "text",
            default: "Buncho Coffee",
          },
          {
            key: "intro2Text",
            label: "Intro 2 Text",
            type: "textarea",
            default: "Buncho is a wholesale wing...",
          },
        ],
      },
      {
        sectionTitle: "Farm to Cup",
        fields: [
          {
            key: "farmMainTitle",
            label: "Main Title",
            type: "text",
            default: "From Farm to Cup",
          },
          {
            key: "italicQuote",
            label: "Center Quote",
            type: "textarea",
            default: '"In every Ethiopian heart..."',
          },
          // ⚡ SMART REPEATER
          {
            key: "farmList",
            label: "Farm to Cup Cards",
            type: "repeater",
            defaultCount: 3,
            itemFields: [
              { key: "image", label: "Card Image", type: "image" },
              {
                key: "title",
                label: "Card Title",
                type: "text",
                default: "Step Title",
              },
              {
                key: "text",
                label: "Card Text",
                type: "textarea",
                default: "Step Description...",
              },
            ],
          },
        ],
      },
      {
        sectionTitle: "Wholesale",
        fields: [
          {
            key: "wholesaleTitle",
            label: "Main Title",
            type: "text",
            default: "WholeSale",
          },
          {
            key: "wholesaleText",
            label: "Intro Text",
            type: "textarea",
            default: "At Buncho Coffee, we are proud...",
          },
          {
            key: "wsContactLabel",
            label: "Contact Label",
            type: "text",
            default: "For Wholesale service call",
          },
          {
            key: "wsPhoneDisplay",
            label: "Phone (Display)",
            type: "text",
            default: "(+251)92-422-22-00",
          },
          {
            key: "wsPhoneRaw",
            label: "Phone (Link format)",
            type: "text",
            default: "+251924222200",
          },
          // ⚡ SMART REPEATER
          {
            key: "wholesaleList",
            label: "Wholesale Detail Cards",
            type: "repeater",
            defaultCount: 5,
            itemFields: [
              { key: "image", label: "Card Image", type: "image" },
              {
                key: "title",
                label: "Card Title",
                type: "text",
                default: "Wholesale Title",
              },
              {
                key: "text",
                label: "Card Text",
                type: "textarea",
                default: "Wholesale Description...",
              },
            ],
          },
        ],
      },
      {
        sectionTitle: "Export & Behind Scenes",
        fields: [
          {
            key: "exportTitle",
            label: "Export Title",
            type: "text",
            default: "Export",
          },
          {
            key: "exportText",
            label: "Export Description",
            type: "textarea",
            default: "We take pride in sharing...",
          },
          { key: "exportImage", label: "Export Main Image", type: "image" },
          {
            key: "expContactLabel",
            label: "Contact Label",
            type: "text",
            default: "To make orders or for more information",
          },
          {
            key: "expPhone",
            label: "Phone Line",
            type: "text",
            default: "(+251)91-098-5454",
          },
          {
            key: "expWechat",
            label: "WeChat ID",
            type: "text",
            default: "@Rudypooh",
          },
          {
            key: "expEmail1",
            label: "Email 1",
            type: "text",
            default: "Bethlehem@dukamocoffee.com",
          },
          {
            key: "expEmail2",
            label: "Email 2",
            type: "text",
            default: "info@bunchocoffee.com",
          },
          {
            key: "behindScenesTitle",
            label: "Behind Scenes Title",
            type: "text",
            default: "Behind the Scene",
          },
          {
            key: "behindScenesText",
            label: "Behind Scenes Text",
            type: "textarea",
            default: "Behind the scenes...",
          },
          {
            key: "behindScenesImage",
            label: "Behind Scenes Image",
            type: "image",
          },
          {
            key: "behindScenesCaption",
            label: "Image Caption",
            type: "text",
            default: "Roasting a 15kg batch",
          },
        ],
      },
      {
        sectionTitle: "Recommendations",
        fields: [
          {
            key: "recoMainTitle",
            label: "Main Title",
            type: "text",
            default: "Roasting, Grinding and Brewing Recommendations",
          },
          {
            key: "recoIntro",
            label: "Intro Text",
            type: "textarea",
            default: "Here's our recommendation...",
          },
          // ⚡ SMART REPEATER
          {
            key: "recoList",
            label: "Recommendation Cards",
            type: "repeater",
            defaultCount: 4,
            itemFields: [
              { key: "image", label: "Card Image", type: "image" },
              {
                key: "title",
                label: "Card Title",
                type: "text",
                default: "Coffee Style",
              },
              {
                key: "roast",
                label: "Roast Level Text",
                type: "textarea",
                default: "Medium to Dark.",
              },
              {
                key: "grind",
                label: "Grind Size Text",
                type: "textarea",
                default: "Medium-Fine.",
              },
              {
                key: "tips",
                label: "Brewing Tips Text",
                type: "textarea",
                default: "Allow the grounds to steep...",
              },
            ],
          },
        ],
      },
    ],
  },

  // 3. DUKAMO MAFI
  "location-mafi": {
    title: "Edit Dukamo Mafi",
    sections: [
      {
        sectionTitle: "Intro & Video",
        fields: [
          {
            key: "introTitle",
            label: "Page Title",
            type: "text",
            default: "Dukamo Mafi",
          },
          {
            key: "introText",
            label: "Intro Description",
            type: "textarea",
            default: "Step into Dukamo Mafi...",
          },
          {
            key: "introSlide",
            label: "Hero Slider Images",
            type: "dynamic_gallery",
          },
          {
            key: "videoSource",
            label: "Tournament Video (MP4)",
            type: "video",
          },
          {
            key: "videoThumbnail",
            label: "Video Thumbnail/Poster",
            type: "image",
          },
          {
            key: "videoCaption",
            label: "Video Caption",
            type: "text",
            default: "Experience the Art of Competition",
          },
        ],
      },
      {
        sectionTitle: "Champions & Gallery",
        fields: [
          {
            key: "featureTitle1",
            label: "Feature 1 Title",
            type: "text",
            default: "Exceptional Coffee & Signature Drinks",
          },
          { key: "featureText1", label: "Feature 1 Text", type: "textarea" },
          {
            key: "featureImage1",
            label: "Feature 1 Image (V60)",
            type: "image",
          },
          { key: "featureTitle2", label: "Champion 1 Title", type: "text" },
          { key: "featureText2", label: "Champion 1 Text", type: "textarea" },
          {
            key: "featureImage2",
            label: "Champion 1 Image (Abatu)",
            type: "image",
          },
          { key: "championTitle2", label: "Champion 2 Title", type: "text" },
          { key: "championText2", label: "Champion 2 Text", type: "textarea" },
          {
            key: "championImage2",
            label: "Champion 2 Image (Fisseha)",
            type: "image",
          },
          {
            key: "runnerSlide",
            label: "Runner Up Gallery (Slider)",
            type: "dynamic_gallery",
          },
          {
            key: "runnerSliderText",
            label: "Slider Overlay Text",
            type: "text",
          },
        ],
      },
      {
        sectionTitle: "Food & Contact",
        fields: [
          {
            key: "foodTitle",
            label: "Food Title",
            type: "text",
            default: "More Than Just Coffee",
          },
          { key: "foodText", label: "Food Text", type: "textarea" },
          { key: "galleryImage1", label: "Gallery Image 1", type: "image" },
          { key: "galleryImage2", label: "Gallery Image 2", type: "image" },
          { key: "footerImage", label: "Footer Exterior Image", type: "image" },
          { key: "contactPhone", label: "Phone", type: "text" },
          { key: "contactEmail", label: "Email", type: "text" },
          { key: "hours", label: "Hours", type: "text" },
          { key: "address", label: "Address", type: "text" },
        ],
      },
    ],
  },

  // 4. HAWASSA
  "location-hawassa": {
    title: "Edit Dukamo Hawassa",
    sections: [
      {
        sectionTitle: "Intro & Specialities",
        fields: [
          {
            key: "introTitle",
            label: "Page Title",
            type: "text",
            default: "Dukamo Hawassa",
          },
          { key: "visitText", label: "Subtitle", type: "text" },
          { key: "introText", label: "Intro Description", type: "textarea" },
          {
            key: "hawassaSlider",
            label: "Slider Images",
            type: "dynamic_gallery",
          },
          {
            key: "specialityTitle",
            label: "Speciality Section Title",
            type: "text",
          },
          { key: "spec1Title", label: "Item 1 Title (Jebena)", type: "text" },
          { key: "spec1Text", label: "Item 1 Text", type: "textarea" },
          { key: "spec1Image", label: "Item 1 Image", type: "image" },
          { key: "spec2Title", label: "Item 2 Title (Ranger)", type: "text" },
          { key: "spec2Text", label: "Item 2 Text", type: "textarea" },
          { key: "spec2Image", label: "Item 2 Image", type: "image" },
        ],
      },
      {
        sectionTitle: "Attractions & Info",
        fields: [
          { key: "attractionsTitle", label: "Attractions Title", type: "text" },
          {
            key: "attractionsList",
            label: "Attractions List",
            type: "textarea",
          },
          {
            key: "attractionsImage",
            label: "Attractions Image",
            type: "image",
          },
          { key: "contactPhone", label: "Phone", type: "text" },
          { key: "contactEmail", label: "Email", type: "text" },
          { key: "hours", label: "Hours", type: "text" },
          { key: "address", label: "Address", type: "text" },
        ],
      },
    ],
  },

  // 5. BHERAWI
  "location-bherawi": {
    title: "Edit Dukamo Bherawi",
    sections: [
      {
        sectionTitle: "Intro & Features",
        fields: [
          {
            key: "introTitle",
            label: "Page Title",
            type: "text",
            default: "Dukamo Bherawi",
          },
          { key: "introText", label: "Intro Description", type: "textarea" },
          {
            key: "bherawiSlider",
            label: "Top Slider Images",
            type: "dynamic_gallery",
          },
          { key: "featureTitle1", label: "Feature 1 Title", type: "text" },
          { key: "featureText1", label: "Feature 1 Text", type: "textarea" },
          {
            key: "featureImage1",
            label: "Feature 1 Image (Beans)",
            type: "image",
          },
        ],
      },
      {
        sectionTitle: "Partnership & Info",
        fields: [
          {
            key: "partnershipSubtitle",
            label: "Partnership Subtitle",
            type: "text",
          },
          {
            key: "partnershipTitle",
            label: "Partnership Main Title",
            type: "text",
          },
          {
            key: "partnershipText1",
            label: "Partnership Text 1",
            type: "textarea",
          },
          {
            key: "partnershipText2",
            label: "Partnership Text 2",
            type: "textarea",
          },
          {
            key: "partnershipBack",
            label: "Partnership Image (Back)",
            type: "image",
          },
          {
            key: "partnershipFront",
            label: "Partnership Image (Front)",
            type: "image",
          },
          { key: "contactPhone", label: "Phone", type: "text" },
          { key: "contactEmail", label: "Email", type: "text" },
          { key: "hours", label: "Hours", type: "text" },
          { key: "address", label: "Address", type: "text" },
        ],
      },
    ],
  },

  // 6. CONTACT
  contact: {
    title: "Edit Contact Us",
    sections: [
      {
        sectionTitle: "Contact Info",
        fields: [
          {
            key: "heroTitle",
            label: "Title",
            type: "text",
            default: "Contact Us",
          },
          { key: "subTitle", label: "Subtitle", type: "text" },
          { key: "wholesalePhone", label: "Wholesale Phone", type: "text" },
          { key: "exportPhone", label: "Export Phone", type: "text" },
          { key: "jobPhone", label: "Jobs Phone", type: "text" },
        ],
      },
    ],
  },

  // 7. COFFEE OF THE WEEK
  "coffee-of-the-week": {
    title: "Edit Coffee of the Week",
    sections: [
      {
        sectionTitle: "Hero & Details",
        fields: [
          { key: "heroTitle", label: "Hero Title", type: "text" },
          { key: "heroSubtitle", label: "Hero Subtitle", type: "text" },
          { key: "heroText", label: "Hero Description", type: "textarea" },
          { key: "heroBg", label: "Hero Background Image", type: "image" },
          { key: "roasterLogo", label: "Roaster Logo Banner", type: "image" },
          { key: "roasterInfo", label: "Roaster Details", type: "textarea" },
          { key: "storyTitle", label: "Story Title", type: "text" },
          { key: "storyText", label: "Story Text", type: "textarea" },
          { key: "productImage", label: "Product Bag Image", type: "image" },
          { key: "availabilityText", label: "Availability Note", type: "text" },
        ],
      },
      {
        sectionTitle: "Coffee Roster",
        fields: [
          { key: "c1Title", label: "Coffee 1 Title", type: "text" },
          { key: "c1Details", label: "Coffee 1 Details", type: "textarea" },
          { key: "c2Title", label: "Coffee 2 Title", type: "text" },
          { key: "c2Details", label: "Coffee 2 Details", type: "textarea" },
          { key: "c3Title", label: "Coffee 3 Title", type: "text" },
          { key: "c3Details", label: "Coffee 3 Details", type: "textarea" },
          { key: "c4Title", label: "Coffee 4 Title", type: "text" },
          { key: "c4Details", label: "Coffee 4 Details", type: "textarea" },
          {
            key: "specialText",
            label: "Why It's Special Text",
            type: "textarea",
          },
          { key: "websiteLink", label: "Roaster Website Link", type: "text" },
        ],
      },
    ],
  },
};

function AdminPageEditor() {
  const { pageId } = useParams();
  const navigate = useNavigate();
  const config = PAGE_CONFIG[pageId];

  const [activeSectionIdx, setActiveSectionIdx] = useState(0);
  const [textData, setTextData] = useState({});
  const [files, setFiles] = useState({});
  const [previews, setPreviews] = useState({});
  const [galleryItems, setGalleryItems] = useState({});
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. FETCH DATA (ESLint warning fixed with internal variable & config dependency)
  useEffect(() => {
    if (!config) return;
    setLoading(true);

    const currentAllFields = config.sections.flatMap((s) => s.fields);

    axios
      .get(`/api/pages/${pageId}`)
      .then((res) => {
        const fetchedText =
          res.data && res.data.textFields ? res.data.textFields : {};
        const fetchedImages =
          res.data && res.data.imageFields ? res.data.imageFields : {};

        // Merge Defaults dynamically based on type
        const mergedText = {};
        currentAllFields.forEach((field) => {
          if (field.type === "repeater") {
            mergedText[`${field.key}_count`] =
              fetchedText[`${field.key}_count`] || field.defaultCount || 1;

            // Pre-fill inner item defaults so new cards don't start entirely blank
            const count = mergedText[`${field.key}_count`];
            for (let i = 0; i < count; i++) {
              field.itemFields.forEach((subField) => {
                const compoundKey = `${field.key}_${i}_${subField.key}`;
                if (subField.type !== "image") {
                  mergedText[compoundKey] =
                    fetchedText[compoundKey] || subField.default || "";
                }
              });
            }
          } else if (
            field.type !== "image" &&
            field.type !== "video" &&
            field.type !== "dynamic_gallery"
          ) {
            mergedText[field.key] =
              fetchedText[field.key] || field.default || "";
          }
        });
        setTextData(mergedText);

        // Set Previews (Images & Videos)
        const initialPreviews = {};
        const initialGalleryCounts = {};

        Object.keys(fetchedImages).forEach((key) => {
          initialPreviews[key] = `${fetchedImages[key]}`;
        });

        // Determine gallery counts
        currentAllFields.forEach((field) => {
          if (field.type === "dynamic_gallery") {
            const count = Object.keys(fetchedImages).filter((k) =>
              k.startsWith(field.key + "_"),
            ).length;
            initialGalleryCounts[field.key] = count > 0 ? count : 1;
          }
        });

        setPreviews(initialPreviews);
        setGalleryItems(initialGalleryCounts);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setNotification({ message: "Error loading data", type: "error" });
        setLoading(false);
      });
  }, [pageId, config]);

  // 2. HANDLE CHANGES
  const handleTextChange = (key, val) =>
    setTextData((prev) => ({ ...prev, [key]: val }));

  const handleFileChange = (key, file) => {
    setFiles((prev) => ({ ...prev, [key]: file }));
    setPreviews((prev) => ({ ...prev, [key]: URL.createObjectURL(file) }));
  };

  // 3. GALLERY LOGIC
  const addGalleryItem = (fieldKey) =>
    setGalleryItems((prev) => ({ ...prev, [fieldKey]: prev[fieldKey] + 1 }));
  const removeGalleryItem = (fieldKey) => {
    if (galleryItems[fieldKey] > 1) {
      setGalleryItems((prev) => ({ ...prev, [fieldKey]: prev[fieldKey] - 1 }));
    }
  };

  // 4. SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(textData).forEach((key) => formData.append(key, textData[key]));
    Object.keys(files).forEach((key) => formData.append(key, files[key]));

    try {
      await axios.post(`/api/pages/${pageId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setNotification({ message: "Saved Successfully!", type: "success" });
    } catch (err) {
      setNotification({ message: "Error Saving", type: "error" });
    }
  };

  if (!config)
    return (
      <div className={styles.adminPage}>
        <Navbar />
        <div className={styles.adminContentContainer}>
          <h2>Page Not Found</h2>
        </div>
      </div>
    );

  // Grab active fields to display
  const activeFields = config.sections[activeSectionIdx].fields;

  return (
    <div className={styles.adminPage}>
      <Navbar />
      <div
        className={styles.adminContentContainer}
        style={{ maxWidth: "1300px" }}
      >
        {notification && (
          <Notification
            message={notification.message}
            type={notification.type}
            onClose={() => setNotification(null)}
          />
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 30,
          }}
        >
          <h2>{config.title}</h2>
          <div>
            <button
              onClick={() => navigate("/admin/dashboard")}
              className={styles.adminBtn}
              style={{ marginRight: 15, background: "#333", color: "#fff" }}
            >
              Back
            </button>
            <button
              onClick={handleSubmit}
              className={`${styles.adminBtn} ${styles.primary}`}
            >
              Save Page Changes
            </button>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div
            style={{ display: "flex", gap: "30px", alignItems: "flex-start" }}
          >
            {/* --- SIDEBAR NAVIGATION (SMART TABS) --- */}
            <div
              style={{
                width: "250px",
                flexShrink: 0,
                background: "#111",
                border: "1px solid #222",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              {config.sections.map((sec, idx) => (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setActiveSectionIdx(idx)}
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                    padding: "15px 20px",
                    background:
                      activeSectionIdx === idx ? "#222" : "transparent",
                    color: activeSectionIdx === idx ? "#00e5ff" : "#888",
                    border: "none",
                    borderBottom: "1px solid #222",
                    fontWeight: activeSectionIdx === idx ? "bold" : "normal",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                >
                  {sec.sectionTitle}
                </button>
              ))}
            </div>

            {/* --- FORM CONTENT AREA --- */}
            <div
              style={{
                flex: 1,
                background: "#0a0a0a",
                border: "1px solid #222",
                borderRadius: "8px",
                padding: "30px",
              }}
            >
              <form onSubmit={handleSubmit} className={styles.adminForm}>
                <h3
                  style={{
                    marginTop: 0,
                    marginBottom: "25px",
                    color: "#ccc",
                    borderBottom: "1px solid #333",
                    paddingBottom: "10px",
                  }}
                >
                  Editing: {config.sections[activeSectionIdx].sectionTitle}
                </h3>

                {activeFields.map((field) => {
                  // =====================================
                  // 1. SMART REPEATER (DYNAMIC BOXES)
                  // =====================================
                  if (field.type === "repeater") {
                    const count =
                      parseInt(textData[`${field.key}_count`]) ||
                      field.defaultCount ||
                      1;
                    const items = [];

                    for (let i = 0; i < count; i++) {
                      items.push(
                        <div
                          key={i}
                          style={{
                            background: "#1a1a1a",
                            padding: "15px",
                            marginBottom: "15px",
                            border: "1px solid #333",
                            borderRadius: "6px",
                          }}
                        >
                          <h4
                            style={{
                              color: "#fff",
                              marginTop: 0,
                              borderBottom: "1px solid #333",
                              paddingBottom: "10px",
                            }}
                          >
                            Item {i + 1}
                          </h4>
                          {field.itemFields.map((subField) => {
                            const compoundKey = `${field.key}_${i}_${subField.key}`;
                            return (
                              <div
                                key={compoundKey}
                                className={styles.formGroup}
                              >
                                <label
                                  style={{ color: "#888", fontSize: "0.8rem" }}
                                >
                                  {subField.label}
                                </label>
                                {subField.type === "image" ? (
                                  <div>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      onChange={(e) =>
                                        handleFileChange(
                                          compoundKey,
                                          e.target.files[0],
                                        )
                                      }
                                      style={{ color: "#fff" }}
                                    />
                                    {previews[compoundKey] && (
                                      <img
                                        src={previews[compoundKey]}
                                        alt="Preview"
                                        style={{
                                          marginTop: 8,
                                          height: "60px",
                                          objectFit: "cover",
                                          borderRadius: "4px",
                                          border: "1px solid #333",
                                        }}
                                      />
                                    )}
                                  </div>
                                ) : subField.type === "textarea" ? (
                                  <textarea
                                    rows="3"
                                    value={textData[compoundKey] || ""}
                                    onChange={(e) =>
                                      handleTextChange(
                                        compoundKey,
                                        e.target.value,
                                      )
                                    }
                                    style={{
                                      width: "100%",
                                      background: "#000",
                                      color: "#fff",
                                      border: "1px solid #444",
                                      padding: "8px",
                                    }}
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    value={textData[compoundKey] || ""}
                                    onChange={(e) =>
                                      handleTextChange(
                                        compoundKey,
                                        e.target.value,
                                      )
                                    }
                                    style={{
                                      width: "100%",
                                      background: "#000",
                                      color: "#fff",
                                      border: "1px solid #444",
                                      padding: "8px",
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>,
                      );
                    }

                    return (
                      <div
                        key={field.key}
                        style={{
                          background: "#111",
                          padding: "20px",
                          borderRadius: "8px",
                          border: "1px solid #222",
                          marginBottom: "20px",
                        }}
                      >
                        <label
                          style={{
                            color: "#00e5ff",
                            fontSize: "1.1rem",
                            fontWeight: "bold",
                            display: "block",
                            marginBottom: "15px",
                          }}
                        >
                          {field.label}
                        </label>
                        {items}
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            marginTop: "10px",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() =>
                              handleTextChange(`${field.key}_count`, count + 1)
                            }
                            className={styles.adminBtn}
                            style={{ background: "#00e5ff", color: "#000" }}
                          >
                            + Add New Card
                          </button>
                          {count > 1 && (
                            <button
                              type="button"
                              onClick={() =>
                                handleTextChange(
                                  `${field.key}_count`,
                                  count - 1,
                                )
                              }
                              className={styles.adminBtn}
                              style={{ background: "#444", color: "#fff" }}
                            >
                              - Remove Last Card
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  }

                  // =====================================
                  // 2. DYNAMIC GALLERY LOGIC
                  // =====================================
                  if (field.type === "dynamic_gallery") {
                    const count = galleryItems[field.key] || 1;
                    const inputs = [];

                    for (let i = 0; i < count; i++) {
                      const itemKey = `${field.key}_${i}`;
                      inputs.push(
                        <div
                          key={itemKey}
                          style={{
                            width: "130px",
                            padding: "8px",
                            border: "1px dashed #444",
                            borderRadius: "4px",
                            background: "#1a1a1a",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <label
                            style={{
                              color: "#888",
                              fontSize: "0.75rem",
                              marginBottom: "4px",
                            }}
                          >
                            Img {i + 1}
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleFileChange(itemKey, e.target.files[0])
                            }
                            style={{
                              color: "#fff",
                              fontSize: "0.7rem",
                              width: "100%",
                            }}
                          />
                          {previews[itemKey] ? (
                            <img
                              src={previews[itemKey]}
                              alt="Preview"
                              style={{
                                marginTop: 8,
                                width: "100%",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "2px",
                                border: "1px solid #333",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                marginTop: 8,
                                width: "100%",
                                height: "60px",
                                background: "#222",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "2px",
                              }}
                            >
                              <span
                                style={{ color: "#444", fontSize: "0.7rem" }}
                              >
                                No Img
                              </span>
                            </div>
                          )}
                        </div>,
                      );
                    }

                    return (
                      <div
                        key={field.key}
                        className={styles.formGroup}
                        style={{
                          background: "#111",
                          padding: 15,
                          borderRadius: 5,
                          border: "1px solid #222",
                        }}
                      >
                        <label
                          style={{
                            color: "#00e5ff",
                            display: "block",
                            marginBottom: 10,
                            fontWeight: "bold",
                          }}
                        >
                          {field.label}
                        </label>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                          }}
                        >
                          {inputs}
                        </div>
                        <div
                          style={{
                            marginTop: 15,
                            paddingTop: 10,
                            borderTop: "1px solid #222",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() => addGalleryItem(field.key)}
                            style={{
                              marginRight: 10,
                              padding: "6px 12px",
                              background: "#00e5ff",
                              color: "#000",
                              border: "none",
                              cursor: "pointer",
                              fontWeight: "bold",
                              borderRadius: "3px",
                              fontSize: "0.8rem",
                            }}
                          >
                            + Add Image
                          </button>
                          <button
                            type="button"
                            onClick={() => removeGalleryItem(field.key)}
                            style={{
                              padding: "6px 12px",
                              background: "#333",
                              color: "#fff",
                              border: "none",
                              cursor: "pointer",
                              borderRadius: "3px",
                              fontSize: "0.8rem",
                            }}
                          >
                            Remove Last
                          </button>
                        </div>
                      </div>
                    );
                  }

                  // =====================================
                  // 3. RENDER STANDARD FIELDS
                  // =====================================
                  return (
                    <div key={field.key} className={styles.formGroup}>
                      <label style={{ color: "#00e5ff" }}>{field.label}</label>

                      {field.type === "textarea" ? (
                        <textarea
                          rows="6"
                          value={textData[field.key] || ""}
                          onChange={(e) =>
                            handleTextChange(field.key, e.target.value)
                          }
                          style={{
                            width: "100%",
                            background: "#111",
                            color: "#fff",
                            border: "1px solid #333",
                            padding: "10px",
                          }}
                        />
                      ) : field.type === "image" ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleFileChange(field.key, e.target.files[0])
                            }
                            style={{ color: "#fff", flex: 1 }}
                          />
                          {previews[field.key] && (
                            <img
                              src={previews[field.key]}
                              alt="Preview"
                              style={{
                                height: 60,
                                width: 60,
                                objectFit: "cover",
                                borderRadius: "4px",
                                border: "1px solid #333",
                              }}
                            />
                          )}
                        </div>
                      ) : field.type === "video" ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                          }}
                        >
                          <input
                            type="file"
                            accept="video/*"
                            onChange={(e) =>
                              handleFileChange(field.key, e.target.files[0])
                            }
                            style={{ color: "#fff", flex: 1 }}
                          />
                          {previews[field.key] && (
                            <video
                              src={previews[field.key]}
                              controls
                              style={{
                                height: 60,
                                width: 100,
                                objectFit: "cover",
                                border: "1px solid #333",
                              }}
                            />
                          )}
                        </div>
                      ) : (
                        <input
                          type="text"
                          value={textData[field.key] || ""}
                          onChange={(e) =>
                            handleTextChange(field.key, e.target.value)
                          }
                          style={{
                            width: "100%",
                            background: "#111",
                            color: "#fff",
                            border: "1px solid #333",
                            padding: "10px",
                          }}
                        />
                      )}
                    </div>
                  );
                })}
              </form>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default AdminPageEditor;
